import React, { useState } from "react"
import {
  InputReason,
  Order,
  OrderLineModificationCreateData,
  OrderLineModificationDeleteData,
  OrderLineModificationType,
  OrderLineModificationUpdateData,
  OrderModificationOrderLines
} from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import UPDATE_MODIFICATION from "../../../../../../graphql/mutations/order/modification/orderLines/UpdateModification"
import { ModificationOrderLines } from "../../../../../../classes/order/ModificationOrderLines"
import Reason from "../../../Reason/Reason"
import { ReasonType } from "lib/types/order"
import { isSkipReason } from "../../../../helpers"

type Props = {
  modification: OrderModificationOrderLines
  refetch: () => void
  order: Order
  orderLoading: boolean
}

const ModificationReason = ({ modification, refetch, order, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>(
    !modification?.reason ? ReasonType.SKIP : undefined
  )
  const modifications = new ModificationOrderLines(
    order.Modifications as OrderModificationOrderLines[]
  )

  const [updateModification, { loading }] = useMutation(UPDATE_MODIFICATION, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          orderLines: modification.orderLines.map((orderLine) => ({
            ...orderLine,
            data:
              orderLine.modificationType === OrderLineModificationType.Update
                ? JSON.stringify(
                    modifications.updateOutputToInput(
                      orderLine.data as OrderLineModificationUpdateData
                    )
                  )
                : orderLine.modificationType === OrderLineModificationType.Create
                  ? JSON.stringify(
                      modifications.createOutputToInput(
                        orderLine.data as OrderLineModificationCreateData
                      )
                    )
                  : orderLine.modificationType === OrderLineModificationType.Delete
                    ? JSON.stringify(
                        modifications.deleteOutputToInput(
                          orderLine.data as OrderLineModificationDeleteData
                        )
                      )
                    : JSON.stringify(orderLine.data)
          })),
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          orderLines: modification.orderLines.map((orderLine) => ({
            ...orderLine,
            data:
              orderLine.modificationType === OrderLineModificationType.Update
                ? JSON.stringify(
                    modifications.updateOutputToInput(
                      orderLine.data as OrderLineModificationUpdateData
                    )
                  )
                : orderLine.modificationType === OrderLineModificationType.Create
                  ? JSON.stringify(
                      modifications.createOutputToInput(
                        orderLine.data as OrderLineModificationCreateData
                      )
                    )
                  : JSON.stringify(orderLine.data)
          })),
          reason: null
        }
      }
    }).then(() => setReasonType(ReasonType.SKIP))
  }
  return (
    <Reason
      addReason={addReason}
      removeReason={removeReason}
      reasonType={reasonType}
      setReasonType={setReasonType}
      orderReason={modification.reason}
      loading={loading}
      orderLoading={orderLoading}
    />
  )
}

export default ModificationReason
